import {useMutation} from "@apollo/client";
import {UpdateEventDocument, UpdateEventMutation, UpdateEventMutationVariables} from "generated/graphql";

export const useUpdateEvent = () => useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument);